import LinearProgress from '@mui/material/LinearProgress';
import {Paper} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import DrawerContext from "../../../Context/DrawerContext"
import TablePageContext from "../../../Context/TablePageContext";
import strings from "../../../localization";
import { editNonWorkingDays } from '../../../Services/HR/NonWorkingDaysService';
import NonWorkingDaysForm from '../../../Components/Forms/Pages/HR/NonWorkingDays/NonWorkingDaysForm';
import SnackbarContext from '../../../Context/SnackbarContext';

const formRules = {
    'name': {required: true},
    'fromDate': {required: true},
    'toDate': {required: true},
    'type': {required: true}
}

const EditNonWorkingDays = (props) => {
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.nonWorkingDays.editNonWorkingDay.pageTitle);
    });

    const onSubmit = (data) => {
        setShowLoader(true);

        editNonWorkingDays(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <NonWorkingDaysForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()} />
        </Paper>
    </div>
}

export default EditNonWorkingDays;